import React, { FunctionComponent, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useSetMobileMenuOpen } from '../../state/layout';

interface ContentProps {
  children?: React.ReactNode;
}

export const ContentWrapper: FunctionComponent<ContentProps> = ({ children }) => {
  const setMobileMenuOpen = useSetMobileMenuOpen();
  const scrollRef = useRef<HTMLDivElement>(null);
  const { pathname } = useLocation();

  useEffect(() => {
    scrollRef.current?.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div
      ref={scrollRef}
      className="flex-1 overflow-auto p-4 md:p-6"
      onClick={() => {
        setMobileMenuOpen(false);
      }}
    >
      {children}
    </div>
  );
};
